<template>
  <ui-dialog show max-width="542px" @input="closeDialog">
    <template #header>
      <h3>{{ $t(`message.facebook.configureAlert.title`) }}</h3>
    </template>
    <div class="content">
      <div>
        {{ $t(`message.facebook.configureAlert.description`) }}
      </div>
    </div>
    <template #actions>
      <ui-button color="primary" outlined @click="closeDialog">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button color="primary" @click="goToFacebookAccount">
        {{ $t(`message.facebook.configureAlert.confirmLabel`) }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "FacebookToggleDialog",
  methods: {
    goToFacebookAccount() {
      this.$router.push({ name: "profile-facebook-accounts" });
    },
    closeDialog() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  color: $grey-darker;
}
</style>
